@if (enduserSideNav) {
  <div class="row bg-gray-lighter">
    <div class="col-2 scrollable-form-nav bg-white pt-3 fixed" style="top: 80px">
      @if (!isLoggedInEndUser) {
        <div class="back-text" (click)="sendData()">
          <span>&lt; </span><small>Back</small>
        </div>
      }
      <ol>
        @for (sideNav of enduserSideNav; track sideNav; let i = $index) {
          <li
            (click)="onNavSelected(i, '#' + sideNav.value)"
            [class.active]="i === selectedNavIndex"
            >
            <small>{{ sideNav?.label }}</small>
          </li>
        }
      </ol>
    </div>
    <div class="col-6 px-3 pb-2 scrollable-form-container">
      <form [formGroup]="userForm" autocomplete="off">
        <div id="basicInformation" class="mb-3">
          <p class="fw-bold">Basic Information</p>
          <div formGroupName="demographic">
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">First Name *</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'firstName'"
                  [type]="'text'"
                  [control]="demographic.controls['firstName']"
                  [submitted]="submitted"
                  [required]="true"
                  >
                </app-input>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Middle Name</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'middleName'"
                  [type]="'text'"
                  [control]="demographic.controls['middleName']"
                  [submitted]="submitted"
                  >
                </app-input>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Last Name *</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'lastName'"
                  [type]="'text'"
                  [control]="demographic.controls['lastName']"
                  [submitted]="submitted"
                  [required]="true"
                  >
                </app-input>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Date of Birth *</label>
              </div>
              <div class="col-8">
                <mdb-form-control>
                  <input
                    mdbInput
                    [mdbDatepicker]="dob"
                    type="text"
                    class="form-control"
                    id="dob"
                  [class.is-invalid]="
                    (submitted || userForm.get('demographic.dob')?.touched) &&
                    userForm.get('demographic.dob')?.invalid
                  "
                    formControlName="dob"
                    [required]="true"
                    mask="00/00/0000"
                    [dropSpecialCharacters]="false"
                    [placeholder]="defaultMomentDateFormat"
                  (change)="
                    onDateInputChange({
                      controlName: FORM_CONTROL.DEMOGRAPHIC_DOB
                    })
                  "
                    />
                  <mdb-datepicker-toggle
                    [mdbDatepicker]="dob"
                  ></mdb-datepicker-toggle>
                  <mdb-datepicker
                    [inline]="true"
                    [format]="mdbDateFormat"
                    [maxDate]="maxDate"
                  (dateChanged)="
                    onDateSelectChange({
                      event: $event,
                      controlName: FORM_CONTROL.DEMOGRAPHIC_DOB
                    })
                  "
                    #dob
                  ></mdb-datepicker>
                </mdb-form-control>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Address *</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'addressLine1'"
                  [type]="'text'"
                  [control]="home.controls['addressLine1']"
                  [submitted]="submitted"
                  [required]="true"
                  [placeholder]="'Address Line 1'"
                  >
                </app-input>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4"></div>
              <div class="col-8 row gx-3 pe-0">
                <div class="col-4">
                  <app-input
                    [name]="'city'"
                    [type]="'text'"
                    [control]="home.controls['city']"
                    [submitted]="submitted"
                    [required]="true"
                    placeholder="City *"
                    >
                  </app-input>
                </div>
                <div class="col-4">
                  <app-autocomplete
                    [form]="userForm"
                  [control]="
                    userForm.controls['demographic']
                      .get('address')
                      ?.get('home')
                      ?.get('state')
                  "
                    [data]="states"
                    [name]="'label'"
                    [value]="'value'"
                    [filterKeys]="['value']"
                    [forceUppercase]="true"
                    [commitExactMatchOnBlur]="true"
                    placeholder="State *"
                    [submitted]="submitted"
                    [required]="true"
                    (emitSelectedValue)="receiveAutocompleteValue($event)"
                    >
                  </app-autocomplete>
                </div>
                <div class="col-4 pe-0">
                  <app-input
                    [name]="'zip'"
                    [type]="'text'"
                    [control]="home.controls['zip']"
                    [mask]="'0*'"
                    [maxLength]="5"
                    [submitted]="submitted"
                    [required]="true"
                    placeholder="Zip *"
                    >
                  </app-input>
                </div>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Email</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'email'"
                  [type]="'text'"
                  [control]="demographic.controls['email']"
                  [submitted]="submitted"
                  >
                </app-input>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Phone</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'phone'"
                  [type]="'text'"
                  [control]="demographic.controls['phone']"
                  [mask]="phoneMask"
                  [submitted]="submitted"
                  >
                </app-input>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Language</label>
              </div>
              <div class="col-8">
                <app-select
                  [form]="userForm"
                  [control]="demographic.controls['language']"
                  [controlName]="'language'"
                  [filter]="true"
                  [submitted]="submitted"
                  [data]="languageList"
                  [name]="'name'"
                  [value]="'value'"
                  [clearButton]="true"
                  [placeholder]="'Select language'"
                  (emitSelectedValue)="receiveSelectedValue($event)"
                  class="mb-2"
                  >
                </app-select>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Organization *</label>
              </div>
              <div class="col-8">
                <app-select
                  [form]="userForm"
                  [control]="userForm.controls['organizationId']"
                  [controlName]="'organizationId'"
                  [filter]="false"
                  [submitted]="submitted"
                  [data]="organizationsList"
                  [disabled]="role === 'ADVOCATE'"
                  [name]="'displayName'"
                  [value]="'id'"
                  [required]="true"
                  (emitSelectedValue)="receiveSelectedValue($event)"
                  class="mb-2"
                  >
                </app-select>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Advocate *</label>
              </div>
              <div class="col-8">
                <app-select
                  [form]="userForm"
                  [control]="userForm.controls['advocateId']"
                  [controlName]="'advocateId'"
                  [filter]="false"
                  [submitted]="submitted"
                  [data]="advocateList"
                  [required]="true"
                  [disabled]="role === 'ADVOCATE'"
                  [name]="'displayName'"
                  [value]="'id'"
                  (emitSelectedValue)="receiveSelectedValue($event)"
                  class="mb-2"
                  >
                </app-select>
              </div>
            </div>
            @if (showUserType) {
              <div class="row gx-3 mb-2">
                <div class="col-4 d-flex align-items-center justify-content-end">
                  <label class="text-end">User type</label>
                </div>
                <div class="col-8">
                  <app-select
                    [form]="userForm"
                    [control]="userForm.controls['userType']"
                    [controlName]="'userType'"
                    [filter]="false"
                    [submitted]="submitted"
                    [data]="userTypeList"
                    [name]="'name'"
                    [value]="'value'"
                    (emitSelectedValue)="receiveSelectedValue($event)"
                    class="mb-2"
                    >
                  </app-select>
                </div>
              </div>
            }
          </div>
        </div>
        <div id="personalSafetyInformation" class="mb-3">
          <p class="fw-bold">Personal Safety Information</p>
          <div formGroupName="info">
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Safe Word *</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'safeWord'"
                  [type]="'text'"
                  [control]="userForm.controls['safeWord']"
                  [submitted]="submitted"
                  [required]="true"
                  >
                </app-input>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Duress Word</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'duressWord'"
                  [type]="'text'"
                  [control]="userForm.controls['duressWord']"
                  [submitted]="submitted"
                  [required]="false"
                  >
                </app-input>
              </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end"
                  >Is there an active protective, restraining or no contact order?
                  *</label
                  >
                </div>
                <div class="col-8 pt-1 d-flex align-items-center gap-2">
                  <div>
                    <input
                      type="radio"
                      id="restrainingyes"
                      name="activeRestrainingOrder"
                      required="true"
                      value="yes"
                      formControlName="activeRestrainingOrder"
                      (change)="changeRadioData('restraining', $event)"
                      />
                    <label class="form-check-label" for="followupAll">Yes</label>
                    <input
                      type="radio"
                      id="restrainingno"
                      name="activeRestrainingOrder"
                      required="true"
                      value="no"
                      formControlName="activeRestrainingOrder"
                      (change)="changeRadioData('restraining', $event)"
                      />
                    <label class="form-check-label" for="followupAll">No</label>
                  </div>
                  @if (
                    submitted &&
                    userForm.get('info.activeRestrainingOrder')?.invalid
                    ) {
                    <small
                      class="text-danger"
                      >
                      This is a required field
                    </small>
                  }
                </div>
            </div>
            <div class="row gx-3 mb-2">
              <div class="col-4 d-flex align-items-center justify-content-end">
                <label class="text-end">Protective order or case number</label>
              </div>
              <div class="col-8">
                <app-input
                  [name]="'caseNumber'"
                  [type]="'text'"
                  [control]="userForm.controls['caseNumber']"
                  [submitted]="submitted"
                  >
                </app-input>
              </div>
            </div>
            @if (editEnduser) {
              <div class="row gx-3 mb-2">
                <div class="col-4 d-flex align-items-center justify-content-end">
                  <label class="text-end">Account Number</label>
                </div>
                <div class="col-8">
                  <app-input
                    [name]="'accountNumber'"
                    [type]="'text'"
                    [control]="userForm.controls['accountNumber']"
                    [submitted]="submitted"
                    [required]="false"
                    [readonly]="true"
                    >
                  </app-input>
                </div>
              </div>
            }
            @if (editEnduser) {
              <div class="row gx-3 mb-2">
                <div class="col-4 d-flex align-items-center justify-content-end">
                  <label class="text-end">Device Phone</label>
                </div>
                <div class="col-8">
                  <app-input
                    [name]="'phone'"
                    [type]="'text'"
                    [control]="userForm.controls['devicePhone']"
                    [mask]="phoneMask"
                    [submitted]="submitted"
                    [readonly]="true"
                    >
                  </app-input>
                </div>
              </div>
            }
                </div>
              </div>
              <div id="personCausingHarm" class="mb-3">
                <p class="fw-bold">Person Causing Harm Information</p>
                <div formGroupName="info">
                  <div class="row gx-3 mb-2">
                    <div class="col-4 d-flex align-items-center justify-content-end">
                      <label class="text-end">Name *</label>
                    </div>
                    <div class="col-8">
                      <app-input
                        [name]="'nameOfPerpetrators'"
                        [type]="'text'"
                        [control]="info.controls['nameOfPerpetrators']"
                        [submitted]="submitted"
                        [required]="true"
                        >
                      </app-input>
                    </div>
                  </div>
                  <div class="row gx-3 mb-2">
                    <div class="col-4 d-flex align-items-center justify-content-end">
                      <label class="text-end">Date of Birth *</label>
                    </div>
                    <div class="col-8">
                      <mdb-form-control>
                        <input
                          mdbInput
                          [mdbDatepicker]="perpetratorDob"
                          type="text"
                          class="form-control"
                          id="perpetratorDob"
                        [class.is-invalid]="
                          (submitted ||
                            userForm.get('info.perpetratorDob')?.touched) &&
                          userForm.get('info.perpetratorDob')?.invalid
                        "
                          formControlName="perpetratorDob"
                          [required]="true"
                          mask="00/00/0000"
                          [dropSpecialCharacters]="false"
                          [placeholder]="defaultMomentDateFormat"
                        (change)="
                          onDateInputChange({
                            controlName: FORM_CONTROL.INFO_PERPETRATOR_DOB
                          })
                        "
                          />
                        <mdb-datepicker-toggle
                          [mdbDatepicker]="perpetratorDob"
                        ></mdb-datepicker-toggle>
                        <mdb-datepicker
                          [inline]="true"
                          [format]="mdbDateFormat"
                          [maxDate]="maxDate"
                        (dateChanged)="
                          onDateSelectChange({
                            event: $event,
                            controlName: FORM_CONTROL.INFO_PERPETRATOR_DOB
                          })
                        "
                          #perpetratorDob
                        ></mdb-datepicker>
                      </mdb-form-control>
                    </div>
                  </div>
                  <div class="row gx-3 mb-2">
                    <div class="col-4 d-flex align-items-center justify-content-end">
                      <label class="text-end"
                        >Color, make and model of car *</label
                        >
                      </div>
                      <div class="col-8">
                        <app-input
                          [name]="'modelOfperpetrator'"
                          [type]="'text'"
                          [control]="info.controls['modelOfperpetrator']"
                          [submitted]="submitted"
                          [required]="true"
                          >
                        </app-input>
                      </div>
                    </div>
                    <div class="row gx-3 mb-2">
                      <div class="col-4 d-flex align-items-center justify-content-end">
                        <label class="text-end">License plate *</label>
                      </div>
                      <div class="col-8">
                        <app-input
                          [name]="'perpetratorLicensePlate'"
                          [type]="'text'"
                          [control]="info.controls['perpetratorLicensePlate']"
                          [submitted]="submitted"
                          [required]="true"
                          >
                        </app-input>
                      </div>
                    </div>
                    <div class="row gx-3 mb-2">
                      <div class="col-4 d-flex align-items-center justify-content-end">
                        <label class="text-end"
                          >Do they own or have access to a firearm? *</label
                          >
                        </div>
                        <div class="col-8 pt-1 d-flex align-items-center gap-2">
                          <div>
                            <input
                              type="radio"
                              id="perpetratoryes"
                              name="perpetratorOwns"
                              value="yes"
                              formControlName="perpetratorOwns"
                              (change)="changeRadioData('perpetratorown', $event)"
                              />
                            <label class="form-check-label" for="followupAll">Yes</label>
                            <input
                              type="radio"
                              id="perpetratorno"
                              name="perpetratorOwns"
                              value="no"
                              formControlName="perpetratorOwns"
                              (change)="changeRadioData('perpetratorown', $event)"
                              />
                            <label class="form-check-label" for="followupAll">No</label>
                          </div>
                          @if (
                            submitted && userForm.get('info.perpetratorOwns')?.invalid
                            ) {
                            <small
                              class="text-danger"
                              >
                              This is a required field
                            </small>
                          }
                        </div>
                    </div>
                    <div class="row gx-3 mb-2">
                      <div class="col-4 d-flex align-items-center justify-content-end">
                        <label class="text-end">Additional persons causing harm, if applicable</label>
                      </div>
                      <div class="col-8">
                        <app-input
                          [name]="'harmPersons'"
                          [type]="'text'"
                          [control]="userForm.controls['harmPersons']"
                          [submitted]="submitted"
                          [required]="false"
                          >
                        </app-input>
                      </div>
                    </div>
                </div>
              </div>
              <div id="householdInformation" class="mb-3">
                <p class="fw-bold">Household Information</p>
                <div formGroupName="info">
                  <div class="row gx-3 mb-2">
                    <div class="col-4 d-flex align-items-center justify-content-end">
                      <label class="text-end">Household Members</label>
                    </div>
                    <div class="col-8 d-flex gap-2 align-items-center">
                      <div class="bg-stepper d-flex align-items-center w-50">
                        <label class="px-1">Adult</label>
                        <div class="stepper-rt-border flex-grow-1">
                          <app-input
                            [name]="'adult'"
                            [type]="'number'"
                            [control]="householdMember.controls['adult']"
                            [submitted]="submitted"
                            [required]="true"
                            (input)="onValueChange($event, 'adult')"
                            >
                          </app-input>
                        </div>
                      </div>
                      <div class="bg-stepper d-flex align-items-center w-50">
                        <label class="px-1">Child</label>
                        <div class="stepper-rt-border flex-grow-1">
                          <app-input
                            [name]="'children'"
                            [type]="'number'"
                            [control]="householdMember.controls['children']"
                            [submitted]="submitted"
                            [required]="true"
                            (input)="onValueChange($event, 'children')"
                            >
                          </app-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row gx-3 mb-2">
                    <div class="col-4 d-flex align-items-center justify-content-end">
                      <label class="text-end">Type of Residence *</label>
                    </div>
                    <div class="col-8">
                      <app-select
                        [form]="userForm"
                        [control]="info.controls['typeOfResidence']"
                        [controlName]="'typeOfResidence'"
                        [filter]="false"
                        [submitted]="submitted"
                        [data]="typeOfResidences"
                        [name]="'name'"
                        [value]="'value'"
                        [required]="true"
                        (emitSelectedValue)="receiveSelectedValue($event)"
                        class="mb-2"
                        >
                      </app-select>
                    </div>
                  </div>
                  @if (typeOfResidence === 'land_plot_point') {
                    <div
                      class="row gx-3 mb-2"
                      >
                      <div class="col-4"></div>
                      <div class="col-8 d-flex gap-2 align-items-center">
                        <div class="w-50">
                          <div class="bg-stepper d-flex align-items-center">
                            <label class="px-1 text-nowrap">Latitude *</label>
                            <div class="stepper-rt-border flex-grow-1">
                              <app-input
                                [name]="'latitude'"
                                [type]="'number'"
                                [control]="info.controls['latitude']"
                                [submitted]="submitted"
                                [required]="true"
                                [noStepper]="true"
                                (input)="onValueChange($event, 'latitude')"
                                >
                              </app-input>
                            </div>
                          </div>
                          <div class="error-container" style="min-height: 1.4rem">
                            @if (info.controls['latitude'].errors?.['min']) {
                              <small
                                class="text-danger"
                                >
                                Latitude must be ≥ -90
                              </small>
                            }
                            @if (info.controls['latitude'].errors?.['max']) {
                              <small
                                class="text-danger"
                                >
                                Latitude must be ≤ 90
                              </small>
                            }
                          </div>
                        </div>
                        <div class="w-50">
                          <div class="bg-stepper d-flex align-items-center">
                            <label class="px-1 text-nowrap">Longitude *</label>
                            <div class="stepper-rt-border flex-grow-1">
                              <app-input
                                [name]="'longitude'"
                                [type]="'number'"
                                [required]="true"
                                [control]="info.controls['longitude']"
                                [submitted]="submitted"
                                [noStepper]="true"
                                (input)="onValueChange($event, 'longitude')"
                                >
                              </app-input>
                            </div>
                          </div>
                          <div class="error-container" style="min-height: 1.4rem">
                            @if (info.controls['longitude'].errors?.['min']) {
                              <small
                                class="text-danger"
                                >
                                Longitude must be ≥ -180
                              </small>
                            }
                            @if (info.controls['longitude'].errors?.['max']) {
                              <small
                                class="text-danger"
                                >
                                Longitude must be ≤ 180
                              </small>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="row gx-3 mb-2">
                    <div class="col-4 d-flex align-items-center justify-content-end">
                      <label class="text-end">Entrance Locations *</label>
                    </div>
                    <div class="col-8">
                      <app-select
                        [form]="userForm"
                        [control]="info.controls['entranceLocation']"
                        [controlName]="'entranceLocation'"
                        [filter]="false"
                        [submitted]="submitted"
                        [data]="entranceLocations"
                        [name]="'name'"
                        [value]="'value'"
                        [required]="true"
                        [multiple]="true"
                        (emitSelectedValue)="receiveSelectedValue($event)"
                        class="mb-2"
                        >
                      </app-select>
                    </div>
                  </div>
                  <div class="row gx-3 mb-2">
                    <div class="col-4 d-flex align-items-center justify-content-end">
                      <label class="text-end">Basement/Attic *</label>
                    </div>
                    <div class="col-8">
                      <app-select
                        [form]="userForm"
                        [control]="info.controls['basementAttic']"
                        [controlName]="'basementAttic'"
                        [filter]="false"
                        [submitted]="submitted"
                        [data]="homeTypes"
                        [name]="'name'"
                        [value]="'value'"
                        [required]="true"
                        (emitSelectedValue)="receiveSelectedValue($event)"
                        class="mb-2"
                        >
                      </app-select>
                    </div>
                  </div>
                  <!--<div class="row gx-3 mb-2">
                  <div class="col-4 d-flex align-items-center justify-content-end">
                    <label class="text-end">Subdivision</label>
                  </div>
                  <div class="col-8">
                    <app-input [name]="'subdivision'" [type]="'text'" [control]="userForm.controls['subdivision']"
                      [submitted]="submitted" [required]="false">
                    </app-input>
                  </div>
                </div>-->
                <div class="row gx-3 mb-2">
                  <div class="col-4 d-flex align-items-center justify-content-end">
                    <label class="text-end">Firearms at home? *</label>
                  </div>
                  <div class="col-8 pt-1 d-flex align-items-center gap-2">
                    <div>
                      <input
                        type="radio"
                        id="firearmyes"
                        name="firearmAtHome"
                        value="yes"
                        formControlName="firearmAtHome"
                        (change)="changeRadioData('firearm', $event)"
                        [required]="true"
                        />
                      <label class="form-check-label" for="followupAll">Yes</label>
                      <input
                        type="radio"
                        id="firearmno"
                        name="firearmAtHome"
                        value="no"
                        formControlName="firearmAtHome"
                        (change)="changeRadioData('firearm', $event)"
                        [required]="true"
                        />
                      <label class="form-check-label" for="followupAll">No</label>
                    </div>
                    @if (submitted && userForm.get('info.firearmAtHome')?.invalid) {
                      <small
                        class="text-danger"
                        >
                        This is a required field
                      </small>
                    }
                  </div>
                </div>
              </div>
              <div>
                <div class="row gx-3 mb-2">
                  <div class="col-4 d-flex align-items-center justify-content-end">
                    <label class="text-end">Any Dogs? *</label>
                  </div>
                  <div class="col-8 pt-1 d-flex align-items-center gap-2">
                    <div>
                      <input
                        type="radio"
                        id="dogsyes"
                        name="anyDog"
                        value="yes"
                        formControlName="anyDog"
                        (change)="changeRadioData('dogs', $event)"
                        [required]="true"
                        />
                      <label class="form-check-label" for="followupAll">Yes</label>
                      <input
                        type="radio"
                        id="dogsno"
                        name="anyDog"
                        value="no"
                        formControlName="anyDog"
                        (change)="changeRadioData('dogs', $event)"
                        [required]="true"
                        />
                      <label class="form-check-label" for="followupAll">No</label>
                    </div>
                    @if (submitted && userForm.get('anyDog')?.invalid) {
                      <small
                        class="text-danger"
                        >
                        This is a required field
                      </small>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              @if (!isLoggedInEndUser) {
                <button type="button" (click)="sendData()" class="btn btn-gray-light">
                  Cancel
                </button>
              }
              <button
                type="button"
                class="btn btn-primary"
                (click)="save()"
                [disabled]="loading"
                >
                {{ saveButtonText }}
              </button>
            </div>
          </form>
        </div>
      </div>
    }
